/**
 * Vista Script Component
 *
 * Optimized script loading with different strategies.
 * Similar to Next.js Script component.
 */
'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Script;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
// Track loaded scripts to prevent duplicates
const loadedScripts = new Set();
/**
 * Script component for optimized script loading
 */
function Script({ src, dangerouslySetInnerHTML, strategy = 'afterInteractive', onLoad, onError, onReady, id, ...rest }) {
    const scriptId = id || src;
    React.useEffect(() => {
        // Skip if already loaded
        if (scriptId && loadedScripts.has(scriptId)) {
            onLoad?.();
            return;
        }
        const loadScript = () => {
            const script = document.createElement('script');
            if (src) {
                script.src = src;
                script.async = true;
                script.onload = () => {
                    if (scriptId)
                        loadedScripts.add(scriptId);
                    onLoad?.();
                };
                script.onerror = () => {
                    onError?.();
                };
            }
            else if (dangerouslySetInnerHTML) {
                script.innerHTML = dangerouslySetInnerHTML.__html;
            }
            // Apply additional attributes
            Object.entries(rest).forEach(([key, value]) => {
                if (typeof value === 'string') {
                    script.setAttribute(key, value);
                }
            });
            document.body.appendChild(script);
            if (dangerouslySetInnerHTML) {
                onReady?.();
            }
        };
        switch (strategy) {
            case 'beforeInteractive':
                // Already handled during SSR, just mark as loaded
                if (scriptId)
                    loadedScripts.add(scriptId);
                break;
            case 'afterInteractive':
                // Load immediately after hydration
                loadScript();
                break;
            case 'lazyOnload':
                // Load during idle time
                if ('requestIdleCallback' in window) {
                    window.requestIdleCallback(loadScript);
                }
                else {
                    setTimeout(loadScript, 200);
                }
                break;
            case 'worker':
                // Web worker loading (simplified - would need full worker setup)
                console.warn('[Vista Script] strategy="worker" is experimental');
                loadScript();
                break;
        }
    }, [src, strategy, scriptId]);
    // beforeInteractive scripts are rendered in SSR
    if (strategy === 'beforeInteractive' && src) {
        return (0, jsx_runtime_1.jsx)("script", { src: src, ...rest });
    }
    return null;
}
